<template>
  <a-alert
    message="Index has been successfully deleted!"
    type="success"
    show-icon
  />
</template>

<script>
export default {}
</script>

<style></style>
